import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';

export interface BreadcrumbsProps {
  breadcrumbs: {
    label: ReactNode;
    path?: string;
    match?: string;
  }[];
}

export default function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
  const { pathname } = useLocation();
  return (
    <Breadcrumb
      spacing={1}
      listProps={{ alignItems: 'baseline' }}
      color="black"
      overflow="hidden"
    >
      {breadcrumbs.map(({ path, label, match }, index) => (
        <BreadcrumbItem
          key={typeof label === 'string' ? label : index}
          isCurrentPage={
            typeof match === 'string' && matchPath(match, pathname) !== null
          }
          fontSize={index === 0 ? 'lg' : 'xs'}
          fontWeight={index === 0 ? 'bold' : 'normal'}
          overflow="hidden"
        >
          {path ? (
            <BreadcrumbLink
              as={Link}
              to={path}
              flex={1}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {label}
            </BreadcrumbLink>
          ) : (
            <Box
              flex={1}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {label}
            </Box>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}
